/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { isSameOrigin } from "@cosmos/common-utils";
import { AuthBox, CosmosComponentContextProps } from "@cosmos/components";
import { useAccountId, useAuth } from "@cosmos/next-hooks";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";

import { TemplateProviders } from "../templates";

interface CosmosPageProps {
	componentContext: CosmosComponentContextProps;
}

export const CosmosPageAuth = ({ componentContext }: CosmosPageProps): React.JSX.Element => {
	useAuth();
	const accountId = useAccountId();
	const searchParams = useSearchParams();
	const router = useRouter();
	const state = searchParams.get("state") || searchParams.get("redirectUrl") || "";

	useEffect(() => {
		if (accountId) {
			if (state) {
				if (Array.isArray(state)) {
					const sameOrigin = isSameOrigin(state[0]);
					if (sameOrigin) {
						router.push(state[0]);
					}
				} else {
					const sameOrigin = isSameOrigin(state);
					if (sameOrigin) {
						router.push(state);
					}
				}
			}
		}
	}, [accountId, state, router]);

	const epicServerUrlStr = process.env.NEXT_PUBLIC_EPIC_SERVER_URL || "https://www.unrealengine.com";
	const serverUrl = new URL(epicServerUrlStr);

	return (
		<TemplateProviders componentContext={componentContext}>
			<AuthBox origin={serverUrl.origin} />
		</TemplateProviders>
	);
};
